import React from 'react';
import InputNumber from './InputNumber';

const PortfolioValue = ({ portfolioValue, setPortfolioValue }) => (
  <InputNumber
    label="Min. Portfolio Value"
    getter={portfolioValue}
    setter={setPortfolioValue}
  />
);

export default PortfolioValue;
